import React from 'react';

import classes from './PlusWidget.module.css';

const PlusWidget = ( { onClick, className } ) => 
    <div className={ [ classes.Plus, className || '' ].join( ' ' ) }
        onClick={ onClick } >&#xFF0B;</div>;

export default PlusWidget;